import React from 'react';

import HistoryIcon from '@material-ui/icons/History';
import RestorePageIcon from '@material-ui/icons/RestorePage';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import PlaceIcon from '@material-ui/icons/Place';

import RouteConfig from '../../config/appRoute/RouteConfig';
import { FUNCTIONS } from '../../constants/APDConstants';

const ClockInOutManagementMenu = [
    {
        functionId: FUNCTIONS.CLOCKINOUT_HISTORY.id,
        icon: <HistoryIcon />,
        label: 'ประวัติการบันทึกเวลา',
        to: RouteConfig.CLOCKINOUT_HISTORY,
    },
    {
        functionId: FUNCTIONS.CLOCKINOUT_PAST_WORK_HISTORY.id,
        icon: <RestorePageIcon />,
        label: 'ประวัติคำขอเพิ่มบันทึกเวลา',
        to: RouteConfig.CLOCKINOUT_PAST_WORK_HISTORY,
    },
    {
        functionId: FUNCTIONS.CLOCKINOUT_SAP_HISTORY.id,
        icon: <ExitToAppIcon />,
        label: 'ประวัติการนำข้อมูลเข้า SAP',
        to: RouteConfig.CLOCKINOUT_SAP_HISTORY,
    },
    {
        functionId: FUNCTIONS.MEA_BOUNDARY.id,
        icon: <PlaceIcon />,
        label: 'ข้อมูลขอบเขตพื้นที่ กฟน.',
        to: RouteConfig.MEA_BOUNDARY,
    },
];

export default ClockInOutManagementMenu;
